"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var classnames_1 = __importDefault(require("classnames"));
var core_1 = require("@material-ui/core");
var HtmlContent_1 = __importDefault(require("../HtmlContent"));
var constants_1 = require("../../constants");
// eslint-disable-next-line import/no-cycle -- ok because ReadMore can display content via TaskContent
var taskElementContent_1 = __importStar(require("./taskElementContent"));
var LinkElement_1 = __importDefault(require("./LinkElement"));
var elementStateUtils_1 = require("../../elementStateUtils");
var utils_1 = require("./utils");
var stringUtils_1 = require("../../stringUtils");
var styles = function (theme) {
    var _a, _b, _c;
    return (0, core_1.createStyles)({
        root: (_a = {
                position: 'relative',
                clear: 'both',
                width: '100%',
                flex: '0 0 100%',
                '&+&': {
                    marginTop: theme.spacing(8),
                }
            },
            _a[theme.breakpoints.down('sm')] = {
                wordBreak: 'break-word',
                '&+&': {
                    marginTop: theme.spacing(6),
                },
            },
            _a['&$selected'] = {
                border: "2px solid ".concat(theme.palette.primary.main),
                padding: theme.spacing(1),
            },
            _a["&.et_".concat(constants_1.defaultContentElementTypes.box)] = {
                marginTop: theme.spacing(4),
                background: theme.youwell.colors.secondaryBackground,
                color: theme.palette.grey[900],
                boxShadow: theme.shadows[3],
                borderRadius: theme.youwell.shapes.borderRadiusFlatter,
                padding: theme.spacing(2),
                alignSelf: 'flex-start',
                '$root+&': (_b = {
                        marginTop: theme.spacing(8)
                    },
                    _b[theme.breakpoints.down('sm')] = {
                        marginTop: theme.spacing(6),
                    },
                    _b),
                '& figure.table': {
                    margin: '1em -16px',
                    width: 'calc(100% + 32px)',
                },
                '& .htmlcontent a': {
                    color: 'var(--primary-color)',
                },
            },
            _a["&.et_".concat(constants_1.defaultContentElementTypes.card)] = (_c = {
                    flex: '0 0 auto',
                    width: '31%',
                    padding: theme.spacing(1),
                    background: theme.youwell.colors.secondaryBackground,
                    borderRadius: theme.youwell.shapes.borderRadiusFlatter
                },
                _c[theme.breakpoints.down('xs')] = {
                    flex: '0 0 100%',
                },
                _c),
            _a),
        hoveredElement: {
            visibility: 'hidden',
            '$root:hover &': {
                visibility: 'visible',
            },
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: theme.spacing(2),
        },
        title: {
            fontSize: '1.25em',
            flex: '1 1 auto',
        },
        content: {
            '&+&': {
                marginTop: theme.spacing(4),
            },
            '&:empty': {
                display: 'none',
            },
        },
        htmlContent: {},
        linkContent: {},
        accepted: {},
        rejected: {},
        selected: {},
    });
};
var TaskElement = /** @class */ (function (_super) {
    __extends(TaskElement, _super);
    function TaskElement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scrolled = false;
        _this.checkScroll = function () {
            var _a;
            if (((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hash) && _this.props.element && !_this.scrolled) {
                if ("".concat(_this.props.element.id) === window.location.hash.substring(1)) {
                    var el_1 = document.getElementById("".concat(constants_1.contentElemenIdPrefix).concat(window.location.hash.substring(1)));
                    if (el_1) {
                        _this.scrolled = true;
                        setTimeout(function () {
                            var yOffset = -90; // (isDesktop ? -headerHeight : 0) - 10;
                            var y = el_1.getBoundingClientRect().top + window.scrollY + yOffset;
                            if (window.scrollTo) {
                                window.scrollTo({ top: y });
                            }
                            else {
                                document.documentElement.scrollTop = y;
                            }
                            // el.scrollIntoView();
                            // el.scrollIntoView({ behavior: 'smooth' });
                        }, 200);
                    }
                }
            }
        };
        return _this;
    }
    TaskElement.prototype.componentDidMount = function () {
        this.checkScroll();
    };
    TaskElement.prototype.componentDidUpdate = function () {
        this.checkScroll();
    };
    TaskElement.prototype.render = function () {
        var _a;
        var _b, _c;
        var _d = this.props, classes = _d.classes, task = _d.task, taskResponses = _d.taskResponses, element = _d.element, TaskFormProps = _d.TaskFormProps, customElementHandler = _d.customElementHandler, getSpecificTaskResponses = _d.getSpecificTaskResponses, showValidationErrors = _d.showValidationErrors, className = _d.className, onResponse = _d.onResponse, LinkElementProps = _d.LinkElementProps, getProgramItem = _d.getProgramItem, noHiddenStates = _d.noHiddenStates, HoveredElement = _d.HoveredElement, selectedElementId = _d.selectedElementId, addNoContextForImages = _d.addNoContextForImages, elementPreContent = _d.elementPreContent, elementIndex = _d.elementIndex;
        var contentStateContidion = (0, elementStateUtils_1.getElementConditionState)(element, getSpecificTaskResponses, task, getProgramItem);
        var contentState = contentStateContidion === null || contentStateContidion === void 0 ? void 0 : contentStateContidion.state;
        if (contentState === constants_1.elementConditionStates.hidden && !noHiddenStates) {
            return React.createElement("div", { className: classes.hiddenByState, "data-csid": contentStateContidion === null || contentStateContidion === void 0 ? void 0 : contentStateContidion.id });
        }
        var htmlContentPosition = (0, taskElementContent_1.getHtmlContentPosition)(element.elementType, (_b = element.settings) === null || _b === void 0 ? void 0 : _b.contentPosition);
        var showContent = htmlContentPosition > -1;
        // Set as exitNode for early exit from module (used in i.e. public screening programs)
        window.__youwellExitNode = (0, stringUtils_1.parseBoolString)((_c = element.settings) === null || _c === void 0 ? void 0 : _c.exitNode);
        return (React.createElement(React.Fragment, null,
            elementPreContent && elementPreContent(element, elementIndex),
            React.createElement("div", { id: "".concat(constants_1.contentElemenIdPrefix).concat(element.id), "data-csid": contentStateContidion === null || contentStateContidion === void 0 ? void 0 : contentStateContidion.id, className: (0, classnames_1.default)(classes.root, className, (_a = {},
                    _a[classes.accepted] = contentState === constants_1.elementConditionStates.accepted,
                    _a[classes.rejected] = contentState === constants_1.elementConditionStates.rejected,
                    _a[classes.selected] = selectedElementId && element.id === selectedElementId,
                    _a["et_".concat(element.elementType)] = element.elementType && element.elementType !== constants_1.defaultContentElementTypes.default,
                    _a)), style: (0, utils_1.getStylesFromSettings)((element === null || element === void 0 ? void 0 : element.settings) ? element.settings : {}) },
                HoveredElement && (React.createElement(HoveredElement, { taskId: task.id, elementId: element.id, className: classes.hoveredElement })),
                showContent && element.title && (React.createElement("div", { className: classes.header },
                    React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.title }, element.title))),
                htmlContentPosition === 0 && (React.createElement(HtmlContent_1.default, { html: element.htmlContent, className: (0, classnames_1.default)(classes.content, classes.htmlContent), addNoContextForImages: addNoContextForImages })),
                showContent && (React.createElement(LinkElement_1.default, __assign({ link: element.link, className: (0, classnames_1.default)(classes.content, classes.linkContent) }, LinkElementProps))),
                htmlContentPosition === 1 && (React.createElement(HtmlContent_1.default, { html: element.htmlContent, className: (0, classnames_1.default)(classes.content, classes.htmlContent), addNoContextForImages: addNoContextForImages })),
                React.createElement(taskElementContent_1.default, { className: classes.content, task: task, element: element, getProgramItem: getProgramItem, getSpecificTaskResponses: getSpecificTaskResponses, contentState: contentState, customElementHandler: customElementHandler, taskResponses: taskResponses, showValidationErrors: showValidationErrors, onResponse: onResponse, TaskFormProps: TaskFormProps }),
                htmlContentPosition === 2 && (React.createElement(HtmlContent_1.default, { html: element.htmlContent, className: (0, classnames_1.default)(classes.content, classes.htmlContent), addNoContextForImages: addNoContextForImages })))));
    };
    return TaskElement;
}(React.Component));
// @ts-ignore // Typescript doesn't recognise defaultProps for Class Components??
TaskElement.defaultProps = {
    TaskFormProps: null,
    customElementHandler: null,
    LinkElementProps: null,
    taskResponses: null,
    noHiddenStates: false,
    HoveredElement: null,
    selectedElementId: null,
    addNoContextForImages: false,
    elementPreContent: null,
    showValidationErrors: false,
    className: null,
};
exports.default = (0, styles_1.withStyles)(styles)(TaskElement);
